import { inject } from '@angular/core';
import { jwtCredentials } from '@core/signals/auth.signal';
import { AuthService } from '@shared/auth/services/auth.service';
import { JwtTokenService } from '@shared/auth/services/jwt-token.service';

export async function authInitializer(): Promise<boolean> {
  const authService = inject(AuthService);
  const tokenService = inject(JwtTokenService);

  const accessToken = tokenService.getAccessToken();
  const refreshToken = tokenService.getRefreshToken();

  if (accessToken) {
    jwtCredentials.set({ accessToken, refreshToken: refreshToken ?? '' });
    authService.isAuthenticated.set(true);
    return true;
  }

  jwtCredentials.set(null);
  authService.isAuthenticated.set(false);
  return false;
}
